import { combineReducers } from 'redux';
import {
  TABLE_MANAGEMENT_REPORT_SET_LIST,
  TABLE_MANAGEMENT_REPORT_SET_SUMMARY,
  TABLE_MANAGEMENT_REPORT_SET_DETAIL,
  TABLE_MANAGEMENT_REPORT_OPEN_RIGHT_COLUMN,
  TABLE_MANAGEMENT_REPORT_CLOSE_RIGHT_COLUMN,
  TABLE_MANAGEMENT_REPORT_UNSET_FILTER_STATE,
  TABLE_MANAGEMENT_REPORT_SET_FILTER_STATE,
  TABLE_MANAGEMENT_REPORT_SET_CURRENT_PAGE,
  TABLE_MANAGEMENT_REPORT_SET_TOTAL_PAGE,
  TABLE_MANAGEMENT_REPORT_IS_SUBMITTING_FORM,
  TABLE_MANAGEMENT_REPORT_SET_MUST_SCROLL_TOP,
  TABLE_MANAGEMENT_REPORT_SET_IS_SUBMITTING_FORM,
} from 'actions/tableManagement/constants';

import createReducer from 'utils/createReducer';

const currentPage = createReducer(null, {
  [TABLE_MANAGEMENT_REPORT_SET_CURRENT_PAGE]: (draft, { payload }) =>
    payload.currentPage,
});

const filterState = createReducer(
  { keyword: '' },
  {
    [TABLE_MANAGEMENT_REPORT_UNSET_FILTER_STATE]: () => ({
      keyword: '',
    }),

    [TABLE_MANAGEMENT_REPORT_SET_FILTER_STATE]: (draft, { payload }) => ({
      keyword: payload.keyword,
    }),
  }
);

const isSubmittingForm = createReducer(false, {
  [TABLE_MANAGEMENT_REPORT_IS_SUBMITTING_FORM]: (draft, { payload }) =>
    payload.isSubmittingForm,

  [TABLE_MANAGEMENT_REPORT_SET_IS_SUBMITTING_FORM]: (draft, { payload }) =>
    payload.isSubmittingForm,
});

const mustScrollTop = createReducer(false, {
  [TABLE_MANAGEMENT_REPORT_SET_MUST_SCROLL_TOP]: (draft, { payload }) =>
    payload.mustScrollTop,
});

const openRightColumn = createReducer(false, {
  [TABLE_MANAGEMENT_REPORT_OPEN_RIGHT_COLUMN]: () => true,
  [TABLE_MANAGEMENT_REPORT_CLOSE_RIGHT_COLUMN]: () => false,
});

const outlets = createReducer([], {});

const reportDetail = createReducer(null, {
  [TABLE_MANAGEMENT_REPORT_SET_DETAIL]: (draft, { payload }) => payload.report,
});

const reports = createReducer([], {
  [TABLE_MANAGEMENT_REPORT_SET_LIST]: (draft, { payload }) => payload.reports,
});

const search = createReducer('', {});
const setting = createReducer({}, {});

const summary = createReducer(
  { total_pages: 0, total_items: 0, completed: 0, cancelled: 0 },
  {
    [TABLE_MANAGEMENT_REPORT_SET_SUMMARY]: (draft, { payload }) =>
      payload.reportSummary,
  }
);

const totalPage = createReducer(null, {
  [TABLE_MANAGEMENT_REPORT_SET_TOTAL_PAGE]: (draft, { payload }) =>
    payload.totalPage,
});

export default combineReducers({
  currentPage,
  filterState,
  isSubmittingForm,
  mustScrollTop,
  openRightColumn,
  outlets,
  reportDetail,
  reports,
  search,
  setting,
  summary,
  totalPage,
});
